import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { Scoped } from "kremling"
import { bindActionCreators } from "redux"
import { Route, Switch, withRouter } from "react-router-dom"
import styles from "../root.krem.css"

import * as actions from "./services/actions"
import { getLevelId } from "./AdminDashboardContainer/components/utils"

// Components
import Company from "./AdminDashboardContainer/Views/Company"
import Department from "./AdminDashboardContainer/Views/Department"
import Team from "./AdminDashboardContainer/Views/Team"
import ReportsDashboards from "./dashboards/ReportsDashboards"

const VisionContainer = props => {
  const { history } = props
  const { id } = getLevelId(history)

  return (
    <Scoped postcss={styles}>
      <Switch>
        <Route
          exact
          path="/engagement/vision2/insights"
          render={() => <Company {...props} key={`company-${id}`} />}
        />
        <Route
          path="/engagement/vision2/insights/department"
          render={() => (
            <Department {...props} title="Team" key={`department-${id}`} />
          )}
        />
        <Route
          path="/engagement/vision2/insights/team"
          render={() => <Team {...props} title="People" key={`team-${id}`} />}
        />
        <Route
          path="/engagement/vision2/dashboards/keyinsights"
          render={() => (
            <ReportsDashboards dashboardId="key-insights" {...props} />
          )}
        />
        <Route
          path="/engagement/vision2/dashboards/repeatperformers"
          render={() => (
            <ReportsDashboards
              dashboardId="top-bottom-repeat-performers"
              {...props}
            />
          )}
        />
        <Route
          path="/engagement/vision2/dashboards/riskiestgroups"
          render={() => (
            <ReportsDashboards dashboardId="riskiest-groups" {...props} />
          )}
        />
      </Switch>
    </Scoped>
  )
}

VisionContainer.propTypes = {
  history: PropTypes.shape({}).isRequired
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  actions: bindActionCreators(actions, dispatch)
})

export default withRouter(connect(mapDispatchToProps)(VisionContainer))
